import Slider from '~/themes/base/components/content/Slider'

export default {
  extends: Slider,
}
